<template>
  <div class="outer">
      <div class="lunbobox">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item,index) in  lunboList" :key="index">
        <img :src="item" alt />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</div>

    <div class="body">
      <div class="activeBox">
        <div class="active_Container">
          <div class="leftImgbox">
            <img src="../../assets/image/my/card-tb.png" alt="">
          </div>
 <div class="centerTxt">
  <div class="tittle">
    <p>健康卡激活</p>
  </div>
  
<div class="containerTxt">
  <span> 激活您的健康卡，一键尽享健康服务, 66889人已激活使用  </span>
</div>

 </div>



<div class="hl_rightBtn">
  <button @click="toAcitiveCard">立即激活</button>
</div>

        </div>
      </div>
<mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" class="mescroll">
      <div class="cardListBox">
         
        <div class="cardList_item" v-for="(item,i) in CardList " :key="i" @click="pushCardDetail(item.cardUid)" >
          <div class="img_box">
            <img :src="item.imgUrl" alt />
          </div>
          <div class="txt_box">
            <span>{{item.packageName}}</span>
          </div>
        </div>
         

      </div>
       </mescroll-vue>
    </div>

    <div class="bottomTab">
      <div @click="hometab" class="bottomTab_item item_home">
        <div class="item_Container">
          <div class="item_img">
            <img src="../../assets/image/tab/homeTab_no.png" alt />
          </div>
          <div class="item_txt home_txt">
            <span>首页</span>
          </div>
        </div>
      </div>
      <div @click="healthCard" class="bottomTab_item item_healthy">
        <div class="item_Container">
          <div class="item_img">
            <img src="../../assets/image/tab/healthCard_yes.png" alt />
          </div>
          <div class="item_txt txt_healthCard">
            <span>健康卡</span>
          </div>
        </div>
      </div>
      <div @click="myTab" class="bottomTab_item item_my">
        <div class="item_Container">
          <div class="item_img">
            <img src="../../assets/image/tab/myTab_no.png" alt />
          </div>
          <div class="item_txt txt_my">
            <span>个人中心</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import AlertBox from "../../components/alert-box";
import { getApi, postApi } from "../../api/index.js";
import {AppIdName,TokenName,jxAppId} from '../../api/api.js';
export default {
  components: {
    MescrollVue, // 注册mescroll组件
    "alert-box-item": AlertBox
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击小圆点跳转
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },


 mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 5 //每页数据条数,默认10
        },
        htmlNodata: '<p class="upwarp-nodata">所有卡卷已经全部加载完成</p>',
        noMoreSize: 5, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: "cardList", //父布局的id (1.3.5版本支持传入dom元素)
          tip: "暂无相关卡卷数据~" //提示
        }
      },

      lunboList: [],
  CardList : []
    };
  },
  created: function() {
    this.getLunbo();
  },
  methods: {

// 给每个卡卷列表添加点击事件
pushCardDetail(cardUid){
// 跳转
this.$router.push({
  path:'/system/coupon',
  query:{cardUid:cardUid}
})
},
// 跳转激活卡卷页面
toAcitiveCard(){
this.$router.push('/system/activate')
},
    // 获取轮播数据
    getLunbo() {
      getApi({ url: "/card/lunbo" })
        .then(res => {
          this.lunboList = res.data;
          console.log(this.lunboList);
        })
        .catch(res => {
        });
    },
  mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      // 联网请求
      getApi({ url:"/card/list/" + page.num, query: {} })
        .then(response =>{
          // 请求的列表数据
          let arr = response.data;
          // 如果是第一页需手动置空列表
          if (page.num === 1) this.CardList = [];
          // 把请求到的数据添加到列表
          this.CardList = this.CardList.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() =>{
            mescroll.endSuccess(arr.length);
          });
        })
        .catch(e => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    },
    //  底部导航切换
    hometab() {
      this.$router.push("/home?appid="+localStorage.getItem(AppIdName));
    },
    healthCard() {
      this.$router.push("/system/healthCard");
    },
    myTab() {
      this.$router.push("/my?appid="+localStorage.getItem(AppIdName));
    }
  }
};
</script>

<style lang="less" scoped>
.body {
  overflow: hidden;
  border: 0px solid transparent;
  padding: 0 0.32rem;
  box-sizing: border-box;
  background-color: #eff3f4;
}
.lunbobox{
    width: 100%;
    position: relative;
    z-index: 1;
}

.activeBox {
  margin-top: 0.3rem; 
  margin-bottom: 0.3rem;
  position: relative;
  .active_Container{
    display: flex;
    // position: absolute;
     height: 1.75rem;
    width: 100%;
    left: 0;
    z-index: 999;
    // top: 0.1rem;
    bottom: 0.4rem;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    display: box;
    display: -webkit-box;
    box-sizing: border-box;


.leftImgbox{
width: 25%;
img{
  display: block;
  margin: 0.27rem auto;
  width: 1.15rem;
  height: 1.15rem;
}
}
.centerTxt{
  padding-top: 0.25rem;
  width: 50%;
  .tittle{
  font-size: 0.4rem;
  font-weight: bold;
  }
  .containerTxt{
    color: #787878;
    font-size: 0.2rem;
  }
}
.hl_rightBtn{
width: 25%;
height: 100%;
button{
  width: 1.6rem;
  height: 0.6rem;
  border-radius: 0.3rem;
  color: #ffffff;
  background-color: #1380e9;
  border: 0px;
  display: block;
  margin: 0.7rem auto;
}

}


  }
}

.cardListBox {
  // margin-bottom: 0.8rem;
//   overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  border-radius: 0.1rem;
  .cardList_item {
    margin-bottom: 0.2rem;
    border-radius: 0.3rem;
    background: #fff;
    width: 45%;
    margin-left: 0.2rem;
    .img_box {
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      margin: 0 auto;
      width: 2.5rem;
      height: 1.8rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .txt_box {
      padding-bottom: 0.2rem;
      width: 100%;
      text-align: center;
    }
  }
}
.bottomTab {
  border: 0px solid transparent;
  overflow: hidden;
  display: flex;
  width: 100%;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  .bottomTab_item {
    width: 33.33%;
    text-align: center;
	.item_Container {
      margin: 0 auto;
      .item_img {
        img {
         width: 0.6rem;
          height: 0.6rem;
        }
      }
      .txt_healthCard {
        color: #1380e9;
      }
      .item_txt {
        padding-bottom: 0.05rem;
        font-size: 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>
